type GoogleMapsPlace = {
  name?: string | null;
  address?: string | null;
  latitude?: number | string | null;
  longitude?: number | string | null;
  placeId?: string | null;
};

export function buildGoogleMapsPlaceQuery(place: GoogleMapsPlace): string | null {
  const name = String(place.name || "").trim();
  const address = String(place.address || "").trim();
  if (address) return [name, address].filter(Boolean).join(", ");

  const latitude = Number(place.latitude);
  const longitude = Number(place.longitude);
  return Number.isFinite(latitude) && Number.isFinite(longitude)
    ? `${latitude},${longitude}`
    : null;
}

export function buildGoogleMapsSearchUrl(place: GoogleMapsPlace): string | null {
  const query = buildGoogleMapsPlaceQuery(place);
  const placeId = String(place.placeId || "").trim();
  if (!query && !placeId) return null;
  const effectiveQuery = query || placeId;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(effectiveQuery)}`
    + (placeId ? `&query_place_id=${encodeURIComponent(placeId)}` : "");
}

export function buildGoogleMapsDirectionsUrl(place: GoogleMapsPlace): string | null {
  const destination = buildGoogleMapsPlaceQuery(place);
  const placeId = String(place.placeId || "").trim();
  if (!destination && !placeId) return null;
  const effectiveDestination = destination || placeId;
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(effectiveDestination)}`
    + (placeId ? `&destination_place_id=${encodeURIComponent(placeId)}` : "");
}

export function buildGoogleMapsEmbedUrl(place: GoogleMapsPlace): string | null {
  const latitude = Number(place.latitude);
  const longitude = Number(place.longitude);
  const query = Number.isFinite(latitude) && Number.isFinite(longitude) && (latitude !== 0 || longitude !== 0)
    ? `${latitude},${longitude}`
    : buildGoogleMapsPlaceQuery(place);
  return query
    ? `https://maps.google.com/maps?q=${encodeURIComponent(query)}&output=embed`
    : null;
}
